import Heading from "src/Pages/Company/Dashboard/components/Heading";

const EmployeeProfile = () => <Heading />;

export default EmployeeProfile;
